import { render } from "./StoragePoolSelectView.vue?vue&type=template&id=3af563c2&scoped=true"
import script from "./StoragePoolSelectView.vue?vue&type=script&lang=js"
export * from "./StoragePoolSelectView.vue?vue&type=script&lang=js"

import "./StoragePoolSelectView.vue?vue&type=style&index=0&id=3af563c2&scoped=true&lang=scss"

import exportComponent from "/jenkins/workspace/acs-deb-pkg-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3af563c2"]])

export default __exports__